/* istanbul ignore file */ /* this file is not used or will be deleted in other branches */
import React, { CSSProperties, Fragment, useMemo } from 'react';
import useFieldApi, { UseFieldApiConfig } from '@data-driven-forms/react-form-renderer/dist/cjs/use-field-api';
import { Field } from '@data-driven-forms/react-form-renderer';
import clsx from 'clsx';

import { generateGridTemplate } from '../../utils/generateGridTemplate';
import { ControlsCellWrapper } from './ControlsCellWrapper';

export function ControlsRowWrapper(props: UseFieldApiConfig) {
  const { input, fields, title, description, isRequired, className, additionalClassName, hideRowIfEmptyInViewMode } =
    useFieldApi(props);

  const style: CSSProperties = useMemo(() => {
    return { gridTemplateColumns: generateGridTemplate(fields) };
  }, [fields]);

  const checkedField = input?.value?.[hideRowIfEmptyInViewMode];
  const readOnly = input?.value?.formConfig?.readOnly;

  if (hideRowIfEmptyInViewMode && !checkedField && readOnly) {
    return <Fragment />;
  }
  return (
    <Fragment>
      <div className='flex justify-between'>
        {title && <h3 className='pt-1 pb-6 font-medium'>{title}</h3>}
        {isRequired && <span className='text-sm'>* Required</span>}
      </div>
      {description && <p>{description}</p>}
      <div className={clsx(!className && 'grid gap-8 mb-3', className, additionalClassName)} style={style}>
        {fields?.map((field: Field) => {
          return <ControlsCellWrapper field={field} key={`${field.name}-wrapper`} />;
        })}
      </div>
    </Fragment>
  );
}
